

import moment, { Moment } from 'moment';
import { NON_EXISTING_RANGER_SOURCE, RangerSourceMap } from '../../ranger_source/model/ranger-source-map.model';
import { RANGER_METADATA } from './ranger.metadata';
import { RangerBase } from './ranger.model.base';
import { CrudEntity, CrudEntityConstructionOptions, PropertyChangeEvent, PropertyMetadata } from '@scisys-uim/uim-common';

export const RANGER_STATUS_ACTIVE: string = 'A';
export const RANGER_STATUS_PENDING: string = 'P';
export const RANGER_STATUS_CLOSED: string = 'C';
export const RANGER_STATUS_ON_LEAVE: string = 'L';

export type RangerDocumentType = 'GENERIC' | 'POLICE_NOTIFICATION';

const FIREARMS_AUTHORITY_VALIDITY_MONTHS = 36;
const PROVISIONAL_FIREARMS_AUTHORITY_EXPIRY_MONTHS = 6;

export interface Ranger extends RangerBase {
  firearmsAuthorityExpiryDate?: Date;
}

export interface RangerTransient { }

export class Ranger extends CrudEntity<Ranger, number, RangerTransient> implements RangerTransient {
  constructor(source?: Partial<Ranger>, options?: CrudEntityConstructionOptions<Ranger, number, RangerTransient>) {
    super(RANGER_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
    this.status = this.status || RANGER_STATUS_ACTIVE;
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  changeOwnProperty(event: PropertyChangeEvent<any, any>, propertyMetadata?: PropertyMetadata): void {
    if (event.property == "firearmsAuthorityIssueDate") {
      var expiryDate = null;
      if (event.newValue != null) {
        var issueDate = moment(event.newValue);
        expiryDate = this.calculateNewExpiryDate(issueDate);
      }
      this.entity['firearmsAuthorityExpiryDate' as any] = expiryDate;
    }
    if (event.property == "provisionalRanger") {
      var expiryDate = null;
      if (this.firearmsAuthorityIssueDate != null) {
        expiryDate = this.calculateNewExpiryDate(moment(this.firearmsAuthorityIssueDate));
      } else {
        expiryDate = null;
      }
      this.entity['firearmsAuthorityExpiryDate' as any] = expiryDate;
    }
  }

  calculateNewExpiryDate(issueDate: Moment) {
    const months = this.provisionalRanger ? PROVISIONAL_FIREARMS_AUTHORITY_EXPIRY_MONTHS : FIREARMS_AUTHORITY_VALIDITY_MONTHS;
    return issueDate.add(months, 'months').toDate();
  }

  get rangerSourceOrDefault(): RangerSourceMap | string {
    if (this.rangerSource != null) {
      return this.rangerSource;
    }
    if (this.email != null) {
      return this.email;
    }
    return NON_EXISTING_RANGER_SOURCE;
  }

  get emailOrRangerSource(): RangerSourceMap | string {
    if (this.rangerSource != null) {
      return this.rangerSource;
    }
    return this.email;
  }

  set emailOrRangerSource(val: RangerSourceMap | string) {
    if (val == null) {
      this.rangerSource = null;
      return;
    }
    if (typeof val == 'string') {
      this.email = val;
      this.rangerSource = null;
      return;
    }

    if (val.sourceExists) {
      this.email = val.sourceEmail;
      this.name = val.sourceName;

      if (this.currentFirearmCount == 0) {
        /* preopulate BU and CC with valid matching ones from source if only 1 value available, the current value is null, and the ranger has no firearms.  
        We don't want these things changing automatically if firearm processes need executing to keep asset and police records in sync.*/
        const bu_list = val.businessUnits;
        const cc_list = val.costCentres;

        if (this.businessUnit == null && bu_list?.length == 1) {
          this.businessUnit = bu_list[0];
        }
        if (this.businessUnit != null && this.costCentre == null && cc_list?.filter(cc => cc.businessUnit?.buId == this.businessUnit.buId)?.length == 1) {
          this.costCentre = cc_list[0];
        }
      }
      this.rangerSource = val;
    }
  }
}